var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1,
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M509 298L576 380L605 333Z",
    fill: "#0d0d0e",
    stroke: "#0d0d0e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509 298L518 439L576 380Z",
    fill: "#0d0d0e",
    stroke: "#0d0d0e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565 522L671 403L576 380Z",
    fill: "#0d0d0e",
    stroke: "#0d0d0e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576 380L671 403L605 333Z",
    fill: "#0d0d0e",
    stroke: "#0d0d0e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727 283L588 186L605 333Z",
    fill: "#060606",
    stroke: "#060606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605 333L588 186L509 298Z",
    fill: "#101112",
    stroke: "#101112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509 298L427 420L518 439Z",
    fill: "#060606",
    stroke: "#060606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461 163L397 266L509 298Z",
    fill: "#131314",
    stroke: "#131314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509 298L397 266L427 420Z",
    fill: "#131314",
    stroke: "#131314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671 403L727 283L605 333Z",
    fill: "#131314",
    stroke: "#131314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510 529L565 522L518 439Z",
    fill: "#151617",
    stroke: "#151617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518 439L565 522L576 380Z",
    fill: "#080808",
    stroke: "#080808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588 186L461 163L509 298Z",
    fill: "#141516",
    stroke: "#141516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427 420L510 529L518 439Z",
    fill: "#0c0c0c",
    stroke: "#0c0c0c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461 163L391 209L397 266Z",
    fill: "#0d0d0e",
    stroke: "#0d0d0e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333 400L390 460L427 420Z",
    fill: "#121213",
    stroke: "#121213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427 420L390 460L510 529Z",
    fill: "#141516",
    stroke: "#141516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333 400L427 420L397 266Z",
    fill: "#0f0f10",
    stroke: "#0f0f10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701 130L577 125L588 186Z",
    fill: "#0f0f10",
    stroke: "#0f0f10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588 186L577 125L461 163Z",
    fill: "#060606",
    stroke: "#060606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565 522L672 505L671 403Z",
    fill: "#131314",
    stroke: "#131314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815 412L779 273L727 283Z",
    fill: "#0c0c0c",
    stroke: "#0c0c0c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727 283L729 214L588 186Z",
    fill: "#0c0c0c",
    stroke: "#0c0c0c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295 289L333 400L397 266Z",
    fill: "#131314",
    stroke: "#131314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815 412L727 283L671 403Z",
    fill: "#0c0c0c",
    stroke: "#0c0c0c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727 283L779 273L729 214Z",
    fill: "#151617",
    stroke: "#151617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821 130L701 130L729 214Z",
    fill: "#101112",
    stroke: "#101112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729 214L701 130L588 186Z",
    fill: "#131314",
    stroke: "#131314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391 209L295 289L397 266Z",
    fill: "#060606",
    stroke: "#060606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527 600L568 600L565 522Z",
    fill: "#080808",
    stroke: "#080808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565 522L676 600L672 505Z",
    fill: "#0c0c0c",
    stroke: "#0c0c0c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527 600L565 522L510 529Z",
    fill: "#0d0d0e",
    stroke: "#0d0d0e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399 600L527 600L510 529Z",
    fill: "#060606",
    stroke: "#060606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577 125L507 61L461 163Z",
    fill: "#0c0c0c",
    stroke: "#0c0c0c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290 138L288 198L391 209Z",
    fill: "#141516",
    stroke: "#141516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391 209L288 198L295 289Z",
    fill: "#0d0d0e",
    stroke: "#0d0d0e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503 0L507 61L630 0Z",
    fill: "#131314",
    stroke: "#131314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819 520L815 412L672 505Z",
    fill: "#151617",
    stroke: "#151617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672 505L815 412L671 403Z",
    fill: "#0a0a0a",
    stroke: "#0a0a0a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363 69L391 209L461 163Z",
    fill: "#0f0f10",
    stroke: "#0f0f10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568 600L676 600L565 522Z",
    fill: "#060606",
    stroke: "#060606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779 273L834 233L729 214Z",
    fill: "#141516",
    stroke: "#141516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 331L834 233L779 273Z",
    fill: "#0c0c0c",
    stroke: "#0c0c0c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338 600L399 600L390 460Z",
    fill: "#101112",
    stroke: "#101112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390 460L399 600L510 529Z",
    fill: "#0d0d0e",
    stroke: "#0d0d0e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338 600L390 460L267 537Z",
    fill: "#080808",
    stroke: "#080808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507 61L363 69L461 163Z",
    fill: "#060606",
    stroke: "#060606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288 198L231 285L295 289Z",
    fill: "#141516",
    stroke: "#141516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295 289L231 285L333 400Z",
    fill: "#141516",
    stroke: "#141516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 177L231 285L288 198Z",
    fill: "#0f0f10",
    stroke: "#0f0f10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363 69L290 138L391 209Z",
    fill: "#0d0d0e",
    stroke: "#0d0d0e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676 600L819 520L672 505Z",
    fill: "#0a0a0a",
    stroke: "#0a0a0a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815 412L900 331L779 273Z",
    fill: "#141516",
    stroke: "#141516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507 61L384 0L363 69Z",
    fill: "#141516",
    stroke: "#141516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630 0L507 61L577 125Z",
    fill: "#131314",
    stroke: "#131314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834 233L821 130L729 214Z",
    fill: "#0c0c0c",
    stroke: "#0c0c0c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701 130L630 0L577 125Z",
    fill: "#060606",
    stroke: "#060606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687 0L630 0L701 130Z",
    fill: "#131314",
    stroke: "#131314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 537L390 460L333 400Z",
    fill: "#0c0c0c",
    stroke: "#0c0c0c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 360L900 331L815 412Z",
    fill: "#0d0d0e",
    stroke: "#0d0d0e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834 233L900 224L821 130Z",
    fill: "#0f0f10",
    stroke: "#0f0f10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 431L267 537L333 400Z",
    fill: "#080808",
    stroke: "#080808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 476L900 360L815 412Z",
    fill: "#0a0a0a",
    stroke: "#0a0a0a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290 138L233 177L288 198Z",
    fill: "#0c0c0c",
    stroke: "#0c0c0c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 98L233 177L290 138Z",
    fill: "#101112",
    stroke: "#101112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819 0L687 0L701 130Z",
    fill: "#151617",
    stroke: "#151617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 331L900 224L834 233Z",
    fill: "#0f0f10",
    stroke: "#0f0f10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503 0L384 0L507 61Z",
    fill: "#101112",
    stroke: "#101112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363 69L312 0L290 138Z",
    fill: "#121213",
    stroke: "#121213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676 600L815 600L819 520Z",
    fill: "#131314",
    stroke: "#131314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819 520L900 476L815 412Z",
    fill: "#0f0f10",
    stroke: "#0f0f10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 600L900 476L819 520Z",
    fill: "#0d0d0e",
    stroke: "#0d0d0e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231 285L179 431L333 400Z",
    fill: "#101112",
    stroke: "#101112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 414L179 431L71 319Z",
    fill: "#0a0a0a",
    stroke: "#0a0a0a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 224L900 129L821 130Z",
    fill: "#121213",
    stroke: "#121213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821 130L819 0L701 130Z",
    fill: "#0a0a0a",
    stroke: "#0a0a0a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 0L312 0L363 69Z",
    fill: "#0f0f10",
    stroke: "#0f0f10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 431L181 529L267 537Z",
    fill: "#101112",
    stroke: "#101112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 537L185 600L338 600Z",
    fill: "#101112",
    stroke: "#101112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 0L819 0L821 130Z",
    fill: "#121213",
    stroke: "#121213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225 0L192 98L290 138Z",
    fill: "#0f0f10",
    stroke: "#0f0f10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 177L129 233L231 285Z",
    fill: "#121213",
    stroke: "#121213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 98L129 233L233 177Z",
    fill: "#0a0a0a",
    stroke: "#0a0a0a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 431L98 485L181 529Z",
    fill: "#0f0f10",
    stroke: "#0f0f10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815 600L900 600L819 520Z",
    fill: "#131314",
    stroke: "#131314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 600L185 600L181 529Z",
    fill: "#080808",
    stroke: "#080808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181 529L185 600L267 537Z",
    fill: "#141516",
    stroke: "#141516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 319L179 431L231 285Z",
    fill: "#121213",
    stroke: "#121213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312 0L225 0L290 138Z",
    fill: "#121213",
    stroke: "#121213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 335L71 319L0 228Z",
    fill: "#151617",
    stroke: "#151617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 414L98 485L179 431Z",
    fill: "#131314",
    stroke: "#131314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 76L129 233L192 98Z",
    fill: "#0a0a0a",
    stroke: "#0a0a0a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129 233L71 319L231 285Z",
    fill: "#121213",
    stroke: "#121213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 414L0 416L98 485Z",
    fill: "#0c0c0c",
    stroke: "#0c0c0c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 129L900 0L821 130Z",
    fill: "#101112",
    stroke: "#101112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 502L109 600L98 485Z",
    fill: "#151617",
    stroke: "#151617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98 485L109 600L181 529Z",
    fill: "#0f0f10",
    stroke: "#0f0f10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137 0L101 76L192 98Z",
    fill: "#101112",
    stroke: "#101112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225 0L137 0L192 98Z",
    fill: "#101112",
    stroke: "#101112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 319L0 416L100 414Z",
    fill: "#131314",
    stroke: "#131314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 228L71 319L129 233Z",
    fill: "#131314",
    stroke: "#131314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 335L0 416L71 319Z",
    fill: "#080808",
    stroke: "#080808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 126L129 233L101 76Z",
    fill: "#131314",
    stroke: "#131314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 126L0 228L129 233Z",
    fill: "#151617",
    stroke: "#151617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 416L0 502L98 485Z",
    fill: "#121213",
    stroke: "#121213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L0 126L101 76Z",
    fill: "#141516",
    stroke: "#141516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 502L0 600L109 600Z",
    fill: "#101112",
    stroke: "#101112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137 0L0 0L101 76Z",
    fill: "#141516",
    stroke: "#141516"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.ce1c1ba101471a2b7d5d9e115d0c145f.svg";
export { ForwardRef as ReactComponent };